
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Clock, BookOpen } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface Course {
  id: string;
  slug?: string;
  title: string;
  description: string;
  shortDescription?: string;
  imageSrc: string;
  price: number | string;
  currency?: string;
  duration: string; // use the duration string from DB
}

interface CourseCardProps {
  course: Course;
}

const CourseCard = ({ course }: CourseCardProps) => {
  return (
    <Card className="overflow-hidden transition-all hover:shadow-md flex flex-col h-full border border-kaija-sage bg-kaija-light">
      <div className="relative h-48 overflow-hidden">
        <img 
          src={course.imageSrc} 
          alt={course.title} 
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
        <Badge className="absolute top-3 right-3 bg-kaija-accent text-white shadow">
          {course.price}&nbsp;{course.currency || "EUR"}
        </Badge>
      </div>
      <CardHeader>
        <CardTitle className="text-xl text-kaija-accent">{course.title}</CardTitle>
      </CardHeader>
      <CardContent className="flex-grow">
        <CardDescription className="text-gray-700 mb-4">
          {course.shortDescription || course.description}
        </CardDescription>
        <div className="flex flex-wrap gap-3 text-sm text-gray-700">
          <div className="flex items-center">
            <Clock className="h-4 w-4 mr-1" />
            {course.duration}
          </div>
        </div>
      </CardContent>
      <CardFooter className="mt-auto">
        {/* Always navigate to the course detail page */}
        <Button asChild className="w-full bg-kaija-accent hover:bg-opacity-90 text-white">
          <Link to={course.slug ? `/course/slug/${course.slug}` : `/course/${course.id}`}>
            Vaata kursust
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default CourseCard;
